/* ============================================================
   REKOVA — Comportements de la fiche produit
   Chaque bloc est indépendant : si une section n'est pas
   présente sur la page, le bloc correspondant ne fait rien.
   Idempotent : sûr à réexécuter après un rechargement de
   section dans l'éditeur de thème.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-rk-media-img]');
    var video = root.querySelector('[data-rk-media-video]');
    var tag = root.querySelector('[data-rk-media-tag]');
    if (!main) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Si le navigateur refuse la lecture automatique (ex. mode économie d'énergie sur iPhone),
       on affiche les commandes du lecteur pour que la vidéo reste lisible d'un geste. */
    function tryPlay() {
      var p = video.play();
      if (p && p.catch) p.catch(function (e) { if (e && e.name === 'NotAllowedError') video.controls = true; });
    }
    if (video) {
      video.muted = true;
      if (still) { video.removeAttribute('autoplay'); video.controls = true; video.pause(); }
      else if (!video.hidden && video.getAttribute('src')) tryPlay();
    }
    function showVideo(t) {
      main.hidden = true;
      video.hidden = false;
      if (video.getAttribute('src') !== t.dataset.video) {
        video.setAttribute('poster', t.dataset.src);
        video.src = t.dataset.video;
      }
      video.muted = true;
      if (!still) tryPlay();
    }
    root.querySelectorAll('[data-rk-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-rk-thumb]').forEach(function (x) {
          x.setAttribute('aria-selected', 'false');
        });
        t.setAttribute('aria-selected', 'true');
        if (tag && t.dataset.tag) tag.textContent = t.dataset.tag;
        if (video && t.dataset.video) { showVideo(t); return; }
        if (video) { video.pause(); video.hidden = true; }
        main.hidden = false;
        main.src = t.dataset.src;
        main.srcset = t.dataset.srcset || '';
      });
    });
  }

  /* ---------- Variantes (tailles) ---------- */
  function initVariants(root) {
    var form = root.querySelector('[data-rk-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-rk-variant-id]');
    var help = root.querySelector('[data-rk-size-help]');
    var sbSize = document.querySelector('[data-rk-sb-size]');
    var priceEl = root.querySelector('[data-rk-price]');
    var submit = form.querySelector('[data-rk-submit]');

    form.querySelectorAll('[data-rk-variant]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (idInput) idInput.value = input.value;
        if (help && input.dataset.help) help.textContent = input.dataset.help;
        if (sbSize) sbSize.textContent = input.dataset.title || '';
        if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;
        if (submit) {
          var unavailable = input.dataset.available === 'false';
          submit.disabled = unavailable;
          if (unavailable) submit.textContent = 'Taille épuisée';
        }
      });
    });

    var openBtn = root.querySelector('[data-rk-open-size]');
    var modal = root.querySelector('[data-rk-size-modal]');
    if (openBtn && modal) {
      openBtn.addEventListener('click', function () { modal.showModal(); });
      var closeBtn = modal.querySelector('[data-rk-close-size]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
    }
  }

  /* ---------- Chambres de compression ---------- */
  function initZones(root) {
    var leg = root.querySelector('[data-rk-leg]');
    if (!leg) return;
    var chambers = Array.prototype.slice.call(leg.querySelectorAll('[data-rk-ch]'));
    var count = root.querySelector('[data-rk-zone-count]');
    var timer = null;

    function refresh() {
      if (!count) return;
      count.textContent = chambers.filter(function (c) {
        return c.getAttribute('aria-pressed') === 'true';
      }).length;
    }

    chambers.forEach(function (c) {
      c.addEventListener('click', function () {
        c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        refresh();
      });
    });

    var slider = root.querySelector('[data-rk-pressure]');
    var val = root.querySelector('[data-rk-pressure-val]');
    if (slider && val) {
      slider.addEventListener('input', function () {
        val.textContent = slider.value + ' mmHg';
      });
    }

    function playWave() {
      if (timer) return;
      var active = chambers.filter(function (c) {
        return c.getAttribute('aria-pressed') === 'true';
      });
      var i = 0;
      timer = setInterval(function () {
        chambers.forEach(function (c) { c.classList.remove('is-pulse'); });
        if (i >= active.length) { clearInterval(timer); timer = null; return; }
        active[i].classList.add('is-pulse');
        i++;
      }, 340);
    }

    var btn = root.querySelector('[data-rk-wave]');
    if (btn) btn.addEventListener('click', playWave);

    if ('IntersectionObserver' in window &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { playWave(); io.disconnect(); }
      }, { threshold: 0.4 });
      io.observe(leg);
    }
  }

  /* ---------- Onglets ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-rk-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        root.querySelectorAll('[data-rk-panel]').forEach(function (p) { p.hidden = true; });
        t.setAttribute('aria-selected', 'true');
        var panel = root.querySelector('#' + t.dataset.rkTab);
        if (panel) panel.hidden = false;
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    root.querySelectorAll('[data-rk-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', String(!open));
        if (q.nextElementSibling) q.nextElementSibling.hidden = open;
      });
    });
  }

  /* ---------- Barre d'achat collante ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-rk-stickybar]');
    var anchor = document.querySelector('[data-rk-cta-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      bar.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Compte à rebours ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-rk-countdown]').forEach(function (el) {
      var target = new Date(el.dataset.rkCountdown);
      if (isNaN(target)) { el.textContent = ''; return; }
      function tick() {
        var d = target - new Date();
        if (d <= 0) { el.textContent = el.dataset.rkCountdownDone || 'Ventes ouvertes'; return; }
        var j = Math.floor(d / 864e5);
        var h = Math.floor((d % 864e5) / 36e5);
        var m = Math.floor((d % 36e5) / 6e4);
        el.textContent = 'J−' + j + ' · ' + h + 'h ' + String(m).padStart(2, '0') + 'm';
      }
      tick();
      setInterval(tick, 30000);
    });
  }

  /* ---------- Boot ---------- */
  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-rk-section]').forEach(function (s) {
      if (s.dataset.rkReady === '1') return;
      s.dataset.rkReady = '1';
      initGallery(s);
      initVariants(s);
      initZones(s);
      initTabs(s);
      initFaq(s);
    });
    initStickyBar();
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Rechargement d'une section dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();